export const styles = {
  label: '!text-text-50 callout-normal',
  value: '!text-text-100 body-paragraphs-normal',
};

export const ftsStatusNameColor = {
  'Отсутствует привязка в M-Pro': 'text-[#FF4728]',
  'Ожидает привязки к M-Pro': 'text-[#D26629]',
  'Проверка годового лимита': 'text-[#D26629]',
  'Превышен годовой лимит': 'text-[#FF4728]',
  'Статус самозанятости отсутствует': 'text-[#FF4728]',
  'Проверка ФИО и телефона': 'text-[#D26629]',
  'Несовпадение ФИО и телефона': 'text-[#FF4728]',
  'Несовпадение ФИО': 'text-[#FF4728]',
  'Несовпадение телефона': 'text-[#FF4728]',
  'Проверки ФНС пройдены': 'text-[#217A0D]',
  'В процессе привязки': 'text-[#D26629]',
  'Техническая ошибка': 'text-[#FF4728]',
};